export const basic = {
  estimate_date: {
    label: 'Estimate Date',
    placeholder: 'Add estimate date',
    dateFormat: 'MM-DD-YYYY',
    utc: true,
    timeFormat: false,
    viewMode: 'days',
    system: {
      name: 'estimate',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'estimate_date',
    rules: {
      title: 'Estimate date field',
      required: true,
    }
  },
  status: {
    label: 'Quote Status',
    placeholder: 'Add quote status',
    system: {
      name: 'status',
    },
    value: 'new',
    errors: [],
    type: 'text',
    name: 'status',
    rules: {
      title: 'Quote status field',
      required: true,
    }
  },
  name: {
    label: 'Name',
    placeholder: 'Add name',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'Name field',
      required: true,
    }
  },
  description: {
    label: 'Description',
    placeholder: 'Add description',
    system: {
      name: 'description',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'description',
    rules: {
      title: 'Description field',
      required: true,
    }
  },
  subtotals: {
    label: 'Subtotals',
    system: {
      name: 'subtotals',
    },
    value: "<table border=\"1\" bordercolor=\"#ccc\" cellpadding=\"5\" cellspacing=\"0\" style=\"border-collapse:collapse\">\n\t<tbody>\n\t\t<tr>\n\t\t\t<td>Subtotal 1</td>\n\t\t\t<td>$00.00</td>\n\t\t</tr>\n\t</tbody>\n</table>\n\n<p>&nbsp;</p>\n",
    errors: [],
    type: 'text',
    name: 'subtotals',
    rules: {
      title: 'Content field',
    },
    helper: 'Press Tab to add new subtotal row or right-click to add new rows and columns',
  },
  total_amount: {
    prefix: '$',
    label: 'Total Amount',
    placeholder: 'Add total amount',
    system: {
      name: 'total_amount',
    },
    value: '0',
    errors: [],
    type: 'text',
    name: 'total_amount',
    rules: {
      title: 'Total amount field',
      required: true,
      min: 0
    }
  },
  amount_tbd: {
    label: 'To be discussed',
    system: {
      name: 'amount_tbd'
    },
    value: false,
    errors: [],
    type: 'text',
    name: 'amount_tbd',
    rules: {}
  },
  customer: {
    label: 'Customer',
    placeholder: 'Add customer',
    system: {
      name: 'customer',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'customer',
    rules: {
      title: 'Customer field',
      required: true,
    }
  },
  contacts: {
    label: 'Customer contacts',
    placeholder: 'Select contacts',
    system: {
      name: 'contacts',
    },
    value: [],
    errors: [],
    type: 'text',
    name: 'contacts',
    rules: {
      title: 'Customer contacts field',
      required: false
    }
  },
  scope_of_work: {
    label: 'Scope of Work',
    placeholder: 'Add content',
    system: {
      name: 'scope_of_work',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'scope_of_work',
    rules: {
      title: 'Content field',
    },
    helper: 'Press Enter to add new paragraph or Shift+Enter to add new line inside of a paragraph',
  },
  sales_rep: {
    label: 'Sales Rep',
    placeholder: 'Choose sales rep',
    system: {
      name: 'sales_rep_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'sales_rep_id',
    rules: {
      title: 'Sales Rep field',
      required: false,
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/QuoteAdd/fields.js